import { useState } from 'react';
import { TextField, Button, Box, Alert, Link as MuiLink } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { AuthLayout } from '@/components/layout';
import { authApi } from '@/api';

export function RecoveryRequestPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await authApi.requestRecovery({ email });
      enqueueSnackbar(t('recovery.codeSent'), { variant: 'success' });
      navigate('/recovery/complete', { state: { email } });
    } catch (err) {
      const message = err instanceof Error ? err.message : t('recovery.resetError');
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title={t('recovery.requestTitle')}
      subtitle={t('recovery.requestDescription')}
    >
      <Box component="form" onSubmit={handleSubmit} noValidate>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label={t('auth.email')}
          name="email"
          autoComplete="email"
          autoFocus
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={loading || !email}
        >
          {loading ? t('common.loading') : t('recovery.requestCode')}
        </Button>

        <Box sx={{ textAlign: 'center' }}>
          <MuiLink component={Link} to="/login" variant="body2">
            {t('common.back')} {t('auth.login')}
          </MuiLink>
        </Box>
      </Box>
    </AuthLayout>
  );
}
